import styled from "styled-components";

const TableColumn = styled.td`
    width: ${({ width }) => width}%;
    padding: 0.6rem !important;
    vertical-align: middle;
`;

export default TableColumn;